import { compose, hoistStatics, withHandlers, lifecycle, withProps, defaultProps, withState } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Item from './Item';
import fh from '../../../helpers/form.helper';
import ModelService from '../../../services/animationsList.service';
import CardLoading from '../../../components/CardLoading';
import WithLoading from '../../../components/WithLoading';
import { uploadSelectors, uploadActions } from '../../../reducers/upload';

const imageSelector = uploadSelectors.getTempFile('logo');

const mapStateToProps = state => ({
  logo: imageSelector(state),
});

const mapDispatchToProps = {
  removeTempFile: uploadActions.removeTempFile,
};

const defaultFormData = {
  name: '',
  status: 1
};

const applyModel = fh.createApplyModel(defaultFormData);

const onSubmit = props => redirect => async (event) => {
  const { logo, isNewModel, history, formData, t } = props;
  await fh.beforeSave(event, props, redirect);
  const { model, errors } = await ModelService.update({
    ...formData,
    logo: logo && logo.id ? logo.id : ''
  });
  if (!errors) {
    if (redirect) return history.push(ModelService.baseRoute);
    if (isNewModel) return history.push(ModelService.getUpdateUrl(model.id));
    await applyModel(props.setFormData, model);
    props.removeTempFile('logo');
    fh.notify(t);
  }
  props.setErrors(!errors ? {} : errors);
  return props.setIsSubmitting(false);
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('countries','setCountries', []),
  withState('searchCity','setSearchCity', ''),
  defaultProps({
    getImage: ModelService.getImage,
  }),
  ...fh.defaultRecompose(defaultFormData),
  lifecycle({
    async componentDidMount() {
      await fh.initModelData(this.props, applyModel, ModelService);
      window.recaptchaOptions = {
        lang: this.props.i18n.language,
      };
    },
  }),
  withProps(props => ({
    title: props.t('Animations list') + fh.getTitleEnd(props),
    imageSrc: props.logo && props.logo.url
      ? props.logo.url : ModelService.getImage(props.formData.logo, 150, 150),
  })),
  withHandlers({
    onSubmit,
    onChange: fh.onChangeFormDataElement,
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(Item, CardLoading)));



// WEBPACK FOOTER //
// ./src/views/animationsLists/item/index.js